import React, { FC } from 'react';

type Props = {
  classCss: string;
  props?: React.SVGProps<SVGSVGElement>;
};
const IconMenu: FC<Props> = ({ classCss, props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 14"
      className={classCss}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M21,17 L21,19 L3,19 L3,17 L21,17 Z M21,11 L21,13 L3,13 L3,11 L21,11 Z M21,5 L21,7 L3,7 L3,5 L21,5 Z"
        transform="translate(-3 -5)"
      />
    </svg>
  );
};

export default IconMenu;
